import { render, staticRenderFns } from "./joat.vue?vue&type=template&id=d9281ea4&scoped=true&"
import script from "./joat.vue?vue&type=script&lang=js&"
export * from "./joat.vue?vue&type=script&lang=js&"
import style0 from "./joat.vue?vue&type=style&index=0&id=d9281ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9281ea4",
  null
  
)

export default component.exports